/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_SubtitleInputs */



/**
* | output |
* | --- |
* | "Build agents that work with your knowledge and tools." |
*
* @param {Agent_Builder_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_subtitle = /** @type {((inputs?: Agent_Builder_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie Agenten, die mit Ihrem Wissen und Ihren Tools arbeiten.")
	return /** @type {LocalizedString} */ ("Build agents that work with your knowledge and tools.")
});